import { render, staticRenderFns } from "./ChatGptBrandingDrawer.vue?vue&type=template&id=1c4311b4"
import script from "./ChatGptBrandingDrawer.vue?vue&type=script&lang=js"
export * from "./ChatGptBrandingDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports